export default function ({ groupedData, productId }) {
    return JSON.stringify({
        product: productId,
        super_group: groupedData
            .reduce((totalGroupedData, { currentQty, defaultQty, productId: singleProductId }) => {
                const qty = currentQty !== undefined ? currentQty : defaultQty;
                return { ...totalGroupedData, [singleProductId]: qty };
            }, {}),
    });
}
